import { render, staticRenderFns } from "./VatsConfig.vue?vue&type=template&id=66508706&scoped=true&"
import script from "./VatsConfig.vue?vue&type=script&lang=js&"
export * from "./VatsConfig.vue?vue&type=script&lang=js&"
import style0 from "./VatsConfig.vue?vue&type=style&index=0&id=66508706&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66508706",
  null
  
)

export default component.exports